import type { Room } from '@hollowveil/shared';

export const roomCrystalLabyrinth: Room = {
      id: 'room_crystal_labyrinth',
      name: "Le Labyrinthe Cristallin",
      description: "Un dédale de cristaux où chaque monde révèle des fragments différents. Collecte-les tous pour forger la Clé de Cristal.",
      size: [34, 14, 34],
      floorStyle: 'crystal',
      ambiance: {
        realWorld: {
          backgroundColor: '#e8f4f8',
          ambientLightColor: '#b3e0ff',
          ambientLightIntensity: 0.7,
        },
        spectralWorld: {
          backgroundColor: '#1a1a2e',
          ambientLightColor: '#6a5acd',
          ambientLightIntensity: 0.4,
        },
      },
      objects: [
        // Crystal walls forming a maze
        {
          id: 'obj_crystal_wall_1',
          name: 'Mur de Cristal',
          type: 'static',
          modelId: 'wall',
          position: [4, 0, 4],
          rotation: [0, 0, 0],
          scale: [0.5, 2.5, 6],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_crystal_wall_2',
          name: 'Mur de Cristal',
          type: 'static',
          modelId: 'wall',
          position: [8, 0, 10],
          rotation: [0, Math.PI / 2, 0],
          scale: [0.5, 2.5, 4],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_crystal_wall_3',
          name: 'Mur de Cristal',
          type: 'static',
          modelId: 'wall',
          position: [14, 0, 6],
          rotation: [0, 0, 0],
          scale: [0.5, 2.5, 8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // RED Crystal Fragment (real world, easy access)
        {
          id: 'obj_crystal_red',
          name: 'Fragment Rouge',
          type: 'interactive',
          modelId: 'crystal',
          position: [2, 0.3, 2],
          rotation: [0, 0, 0],
          scale: [0.7, 1, 0.7],
          visibleInWorld: 'real',
          interactableInWorld: 'real',
          properties: {},
          onInteract: [
            {
              type: 'addToInventory',
              params: {
                itemId: 'crystal_fragment_red',
                itemName: 'Fragment Rouge',
                itemDescription: 'Un fragment de cristal rouge pulsant de chaleur. 1/4',
                itemIcon: 'crystal',
              },
            },
            {
              type: 'showMessage',
              params: {
                message: 'Tu as trouvé le Fragment Rouge ! Il pulse de chaleur.',
              },
            },
            {
              type: 'hideObject',
              params: {
                objectId: 'obj_crystal_red',
              },
            },
          ],
        },
        // BLUE Crystal Fragment (spectral world)
        {
          id: 'obj_crystal_blue',
          name: 'Fragment Bleu',
          type: 'interactive',
          modelId: 'crystal',
          position: [16, 0.3, 16],
          rotation: [0, 0.5, 0],
          scale: [0.7, 1, 0.7],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
          onInteract: [
            {
              type: 'addToInventory',
              params: {
                itemId: 'crystal_fragment_blue',
                itemName: 'Fragment Bleu',
                itemDescription: 'Un fragment de cristal bleu froid comme la glace. 2/4',
                itemIcon: 'crystal',
              },
            },
            {
              type: 'showMessage',
              params: {
                message: 'Tu as trouvé le Fragment Bleu ! Il est froid comme la glace.',
              },
            },
            {
              type: 'hideObject',
              params: {
                objectId: 'obj_crystal_blue',
              },
            },
          ],
        },
        // Door blocking GREEN fragment
        {
          id: 'obj_green_door',
          name: 'Porte de Cristal',
          type: 'interactive',
          modelId: 'animated_door',
          position: [10, 0, 3],
          rotation: [0, Math.PI / 2, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'real',
          interactableInWorld: 'real',
          properties: {},
          onInteract: [
            {
              type: 'openDoorWithItem',
              params: {
                doorId: 'obj_green_door',
                requiredItemId: 'shadow_key',
              },
            },
          ],
        },
        // GREEN Crystal Fragment (behind door, requires shadow_key)
        {
          id: 'obj_crystal_green',
          name: 'Fragment Vert',
          type: 'interactive',
          modelId: 'crystal',
          position: [12, 0.3, 2],
          rotation: [0, 1.2, 0],
          scale: [0.7, 1, 0.7],
          visibleInWorld: 'real',
          interactableInWorld: 'real',
          properties: {},
          onInteract: [
            {
              type: 'addToInventory',
              params: {
                itemId: 'crystal_fragment_green',
                itemName: 'Fragment Vert',
                itemDescription: 'Un fragment de cristal vert vibrant de vie. 3/4',
                itemIcon: 'crystal',
              },
            },
            {
              type: 'showMessage',
              params: {
                message: 'Tu as trouvé le Fragment Vert ! Il vibre de vie.',
              },
            },
            {
              type: 'hideObject',
              params: {
                objectId: 'obj_crystal_green',
              },
            },
          ],
        },
        // Crystal Spirit with riddle for GOLD fragment
        {
          id: 'obj_crystal_spirit',
          name: 'Esprit du Cristal',
          type: 'interactive',
          modelId: 'spectral_remnant',
          position: [6, 0, 14],
          rotation: [0, 0, 0],
          scale: [1.2, 1.2, 1.2],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
          onInteract: [
            {
              type: 'showRiddle',
              params: {
                riddle: {
                  id: 'riddle_crystal_spirit',
                  npcId: 'obj_crystal_spirit',
                  npcName: 'Esprit du Cristal',
                  question: '"Pour obtenir le Fragment Doré, réponds à mon énigme :\n\nJe suis précieux mais ne coûte rien.\nJe suis perdu facilement mais difficile à retrouver.\nTout le monde me possède mais peu me chérissent.\n\nQue suis-je ?"',
                  hint: 'Pense à ce qui passe sans cesse...',
                  type: 'text_input',
                  expectedAnswers: ['le temps', 'temps', 'time', 'du temps'],
                  correctResponse: '"Le temps... Oui, le temps. Voici le Fragment Doré."',
                  incorrectResponse: '"Non, ce n\'est pas cela. Réfléchis à ce qui passe sans jamais revenir..."',
                  canRetry: true,
                  onCorrect: [
                    {
                      type: 'addToInventory',
                      params: {
                        itemId: 'crystal_fragment_gold',
                        itemName: 'Fragment Doré',
                        itemDescription: 'Un fragment de cristal doré brillant de sagesse. 4/4',
                        itemIcon: 'crystal',
                      },
                    },
                  ],
                },
              },
            },
          ],
        },
        // GOLD Crystal Fragment marker (given by riddle)
        {
          id: 'obj_crystal_gold',
          name: 'Fragment Doré',
          type: 'static',
          modelId: 'crystal',
          position: [6, 0.3, 12],
          rotation: [0, 0, 0],
          scale: [0.7, 1, 0.7],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        // Ancient Forge - combines all fragments
        {
          id: 'obj_ancient_forge',
          name: 'Forge Ancienne',
          type: 'interactive',
          modelId: 'block',
          position: [9, 0, 9],
          rotation: [0, 0, 0],
          scale: [2.5, 1.5, 2.5],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { variant: 'stone' },
          onInteract: [
            {
              type: 'showMessage',
              params: {
                message: 'La Forge Ancienne attend les 4 fragments de cristal pour forger la Clé de Cristal.',
              },
            },
          ],
        },
        // Crystal pillars for atmosphere
        {
          id: 'obj_crystal_pillar_1',
          name: 'Pilier de Cristal',
          type: 'static',
          modelId: 'pillar',
          position: [1, 0, 9],
          rotation: [0, 0, 0],
          scale: [0.8, 1, 0.8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { height: 5 },
        },
        {
          id: 'obj_crystal_pillar_2',
          name: 'Pilier de Cristal',
          type: 'static',
          modelId: 'pillar',
          position: [17, 0, 9],
          rotation: [0, 0, 0],
          scale: [0.8, 1, 0.8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { height: 5 },
        },
        // Spectral bridges in the labyrinth
        {
          id: 'obj_crystal_bridge',
          name: 'Pont Spectral',
          type: 'static',
          modelId: 'spectral_bridge',
          position: [9, 0, 14],
          rotation: [0, 0, 0],
          scale: [1.5, 1, 2],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        // === Additional decorations for enlarged labyrinth (34x34) ===
        // More crystal pillars
        {
          id: 'obj_crystal_pillar_3',
          name: 'Pilier de Cristal',
          type: 'static',
          modelId: 'pillar',
          position: [28, 0, 6],
          rotation: [0, 0, 0],
          scale: [0.8, 1.2, 0.8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { height: 5 },
        },
        {
          id: 'obj_crystal_pillar_4',
          name: 'Pilier de Cristal',
          type: 'static',
          modelId: 'pillar',
          position: [22, 0, 28],
          rotation: [0, 0, 0],
          scale: [0.8, 1, 0.8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: { height: 4 },
        },
        {
          id: 'obj_crystal_column_1',
          name: 'Colonne Cristalline',
          type: 'static',
          modelId: 'column',
          position: [6, 0, 30],
          rotation: [0, 0.5, 0],
          scale: [1, 1.2, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // More maze walls
        {
          id: 'obj_crystal_wall_4',
          name: 'Mur de Cristal',
          type: 'static',
          modelId: 'wall',
          position: [24, 0, 14],
          rotation: [0, 0, 0],
          scale: [0.5, 2.5, 8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_crystal_wall_5',
          name: 'Mur de Cristal',
          type: 'static',
          modelId: 'wall',
          position: [18, 0, 24],
          rotation: [0, Math.PI / 2, 0],
          scale: [0.5, 2.5, 6],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_crystal_wall_6',
          name: 'Mur de Cristal',
          type: 'static',
          modelId: 'wall',
          position: [10, 0, 28],
          rotation: [0, 0, 0],
          scale: [0.5, 2.5, 5],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Lanterns
        {
          id: 'obj_crystal_lantern_1',
          name: 'Lanterne Cristalline',
          type: 'static',
          modelId: 'lantern',
          position: [20, 0, 4],
          rotation: [0, 0, 0],
          scale: [1.3, 1.3, 1.3],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_crystal_lantern_2',
          name: 'Lanterne Cristalline',
          type: 'static',
          modelId: 'lantern',
          position: [30, 0, 18],
          rotation: [0, 0, 0],
          scale: [1.3, 1.3, 1.3],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_crystal_lantern_3',
          name: 'Lanterne Cristalline',
          type: 'static',
          modelId: 'lantern',
          position: [14, 0, 32],
          rotation: [0, 0, 0],
          scale: [1.3, 1.3, 1.3],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Rocks and debris
        {
          id: 'obj_crystal_rock_1',
          name: 'Rocher',
          type: 'static',
          modelId: 'rock',
          position: [26, 0, 22],
          rotation: [0, 1.2, 0],
          scale: [1.1, 0.9, 1.1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_crystal_rock_2',
          name: 'Rocher',
          type: 'static',
          modelId: 'rock',
          position: [4, 0, 26],
          rotation: [0, 2.8, 0],
          scale: [0.8, 0.7, 0.8],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_crystal_rocks_1',
          name: 'Cailloux',
          type: 'static',
          modelId: 'rocks',
          position: [30, 0, 10],
          rotation: [0, 0.6, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Crystals for decoration
        {
          id: 'obj_deco_crystal_1',
          name: 'Cristal',
          type: 'static',
          modelId: 'crystal',
          position: [32, 0.2, 4],
          rotation: [0, 0.8, 0],
          scale: [0.5, 0.8, 0.5],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_deco_crystal_2',
          name: 'Cristal',
          type: 'static',
          modelId: 'crystal',
          position: [2, 0.2, 20],
          rotation: [0, 1.5, 0],
          scale: [0.6, 0.9, 0.6],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        {
          id: 'obj_deco_crystal_3',
          name: 'Cristal',
          type: 'static',
          modelId: 'crystal',
          position: [28, 0.2, 30],
          rotation: [0, 2.2, 0],
          scale: [0.7, 1, 0.7],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Spectral orbs
        {
          id: 'obj_crystal_orb_1',
          name: 'Orbe Cristallin',
          type: 'static',
          modelId: 'orb',
          position: [22, 2, 8],
          rotation: [0, 0, 0],
          scale: [0.5, 0.5, 0.5],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        {
          id: 'obj_crystal_orb_2',
          name: 'Orbe Cristallin',
          type: 'static',
          modelId: 'orb',
          position: [8, 2.5, 22],
          rotation: [0, 0, 0],
          scale: [0.4, 0.4, 0.4],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        {
          id: 'obj_crystal_orb_3',
          name: 'Orbe Cristallin',
          type: 'static',
          modelId: 'orb',
          position: [30, 1.8, 26],
          rotation: [0, 0, 0],
          scale: [0.45, 0.45, 0.45],
          visibleInWorld: 'spectral',
          interactableInWorld: 'spectral',
          properties: {},
        },
        // Benches
        {
          id: 'obj_crystal_bench_1',
          name: 'Banc',
          type: 'static',
          modelId: 'bench',
          position: [16, 0, 20],
          rotation: [0, Math.PI / 4, 0],
          scale: [1, 1, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
        // Statues
        {
          id: 'obj_crystal_statue',
          name: 'Statue Cristalline',
          type: 'static',
          modelId: 'statue',
          position: [30, 0, 2],
          rotation: [0, -Math.PI / 3, 0],
          scale: [1, 1.3, 1],
          visibleInWorld: 'both',
          interactableInWorld: 'both',
          properties: {},
        },
      ],
      puzzles: [
        {
          id: 'puzzle_crystal_collection',
          name: 'Les Fragments du Cristal',
          type: 'collection',
          state: 'active',
          description: 'Collecte les 4 fragments de cristal pour forger la Clé de Cristal.',
          hint: 'Deux fragments sont dans le monde réel, deux dans le monde spectral.',
          linkedObjectIds: ['obj_crystal_red', 'obj_crystal_blue', 'obj_crystal_green', 'obj_crystal_gold'],
          solution: {
            type: 'items',
            expected: ['crystal_fragment_red', 'crystal_fragment_blue', 'crystal_fragment_green', 'crystal_fragment_gold'],
          },
          onSolve: [
            {
              type: 'showMessage',
              params: {
                message: 'Les 4 fragments peuvent maintenant être forgés !',
              },
            },
          ],
        },
      ],
      connections: [
        {
          targetRoomId: 'room_shadow_temple',
          position: [0, 0, 9],
          direction: 'west',
          locked: false,
        },
        {
          targetRoomId: 'room_forbidden_library',
          position: [18, 0, 9],
          direction: 'east',
          locked: false,
        },
      ],
      initialWorld: 'real',
      hasSpectralLayer: true,
      palette: 'crystal',
      biome: 'marine',
      weather: 'bubbles',
      weatherIntensity: 0.5,
      npcs: [
        {
          id: 'npc_fish_school',
          type: 'fish',
          name: 'Banc de Poissons',
          position: [12, 1.5, 14],
          scale: 3,
          idleAnimation: 'swim',
          petAnimation: 'spin',
          petRadius: 2.5,
          petCooldown: 1500,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_fish_school_2',
          type: 'fish',
          name: 'Poissons Dorés',
          position: [22, 1, 22],
          scale: 2.5,
          idleAnimation: 'swim',
          petAnimation: 'spin',
          petRadius: 2,
          petCooldown: 1500,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_turtle_1',
          type: 'turtle',
          name: 'Tortue Sage',
          position: [24, 0, 18],
          scale: 3.5,
          idleAnimation: 'swim',
          petAnimation: 'happy',
          petRadius: 3,
          petCooldown: 3000,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_jellyfish_1',
          type: 'jellyfish',
          name: 'Méduse Luminescente',
          position: [16, 2, 12],
          scale: 3,
          idleAnimation: 'swim',
          petAnimation: 'spin',
          petRadius: 2.5,
          petCooldown: 2500,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_crab_1',
          type: 'crab',
          name: 'Crabe Gardien',
          position: [28, 0, 26],
          scale: 3,
          idleAnimation: 'stand',
          petAnimation: 'happy',
          petRadius: 2.5,
          petCooldown: 2000,
          isPettable: true,
          visibleInWorld: 'both',
        },
        {
          id: 'npc_dolphin_1',
          type: 'dolphin',
          name: 'Dauphin Joueur',
          position: [18, 1, 26],
          scale: 3.5,
          idleAnimation: 'swim',
          petAnimation: 'jump',
          petRadius: 4,
          petCooldown: 2500,
          isPettable: true,
          visibleInWorld: 'both',
        },
      ],
};
